import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TotemWidget } from '../totem-widget';

export class TotemWidgetHeroButton { 
    icon:string
    text:string
    color:string
    url?:string
    widget?:string
}

@Component({
    selector: 'app-totem-widget-hero',
    templateUrl: './totem-widget-hero.component.html',
    styleUrls: ['./totem-widget-hero.component.scss'],
    standalone: false
})
export class TotemWidgetHeroComponent extends TotemWidget implements OnInit {

    constructor(public elementRef:ElementRef) {
        super(elementRef)
    }

    @Input() size:'md'|'lg' = 'md'

    @Input() title:string
    @Input() text:string
    @Input() background:string
    @Input() image:string
    @Input() video:string
    @Input() buttons:Array<TotemWidgetHeroButton>

    videoLoadStatus = null;

    ngOnInit(): void {
        if(this.size == null) this.size = 'md'
    }

    onButtonClick(button:TotemWidgetHeroButton) {
        if(button.url) {
            window.open(button.url)
        }
        else if(button.widget) {
            this.requestFullScreen.emit({ widget: button.widget })
        }
    }

    @ViewChild('videoElement') videoElement:ElementRef

    isVideoPlaying = false;

    togglePlayVideo() {
        let _video = this.videoElement?.nativeElement as HTMLVideoElement

        if(_video) {
            if(this.isVideoPlaying) {
                _video.pause()
            }
            else {
                _video.play()
            }
        }
    }
}
